import { array, date, mixed, number, object } from "yup"
import {
  firstName,
  ID,
  lastName,
  phoneNumber,
  registrationNumber,
  ID2,
} from "../yup.common"
export default object({
  id: ID,
  registrationNumber,
  vehicleType: ID2("Vehicle Type"),
  vehicleKind: ID2("Vehicle Kind"),
  dateBought: date().required().label("Vehicle Purchase Date"),
  departments: array(ID),
  estimatedAverage: number().min(0).required().label("Estimated Average"),
  insurance: mixed(),
  depot: mixed().label("Depot"),
  fuelTankCapacity: number().min(0).label("Fuel Tank Capacity"),
  tripRates: array(
    object({
      id: ID,
      tripCount: number()
        .positive("Trip Count cannot be lower than 0!")
        .label("Trip Count"),
      rate: number()
        .positive("Rate cannot be lower than 0!")
        .label("Trip Rate"),
    })
  ).label("Vehicle Trips"),
})

export const quickVehicleModel = object({
  registrationNumber: registrationNumber
    .required("Registration Number is required")
    .label("Registration Number"),

  vehicleType: mixed()
    .required("Vehicle Type is required")
    .label("Vehicle Type"),

  driver: object({
    firstName,
    lastName,
    number: phoneNumber.required(),
  }),
})
